// GLOBAL JS

// HEADER

// Mobile Menu toggle open
document.addEventListener('DOMContentLoaded', function() {
  const menuToggle = document.getElementById('hamburger-toggle');
  const mobileNav = document.getElementById('mobile-menu');
  const htmlElement = document.documentElement;

  mobileNav.classList.add('menu-loaded');
  
  menuToggle.addEventListener('click', function() {
    mobileNav.classList.toggle('active');
    menuToggle.classList.toggle('active');
    menuToggle.classList.toggle('active-close');
    htmlElement.classList.toggle('overflow-hidden');
  });

});

// Localization form JavaScript

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define('localization-form', LocalizationForm);

// FIX THIS AS IT FUCKS WITH NON ANCHOR TAG LINKS
// Smooth scroll and removing the #tag from the URL Bar
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    e.preventDefault();

    const targetId = this.getAttribute('href');
    const targetElement = document.querySelector(targetId);

    if (targetElement) {
      const headerOffset = 145; // Replace with your header's height in px
      const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });

      // Remove the hash from URL after scrolling
      history.pushState("", document.title, window.location.pathname + window.location.search);
    }
  });
});


// Getting header height

function setHeaderHeightVariable() {
  const headerGroup = document.querySelector(".shopify-section-group-header-group");
  
  if (headerGroup) {
    const root = document.documentElement;
    const headerHeight = headerGroup.offsetHeight;
    
    root.style.setProperty('--header-group-height', headerHeight + "px");
  }
}

// Run on page load
document.addEventListener('DOMContentLoaded', setHeaderHeightVariable);

// Run on window resize to handle responsive changes
window.addEventListener('resize', debounce(setHeaderHeightVariable, 100));

// Debounce function to limit resize event calls
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Global Accordion System
document.addEventListener('DOMContentLoaded', function() {
  const accordionHeaders = document.querySelectorAll('.accordion-header');

  accordionHeaders.forEach(function(header) {
    header.addEventListener('click', function(e) {
    const accordionItem = header.closest('.accordion-item');
    const isFooterItem = accordionItem.classList.contains('footer-accordion-item');
    const isMobileItem = accordionItem.classList.contains('mobile-menu-item');
    
    // Footer accordion only works on mobile
    if (isFooterItem && window.innerWidth > 768) return;
    
    const index = header.getAttribute('data-index');
    const content = accordionItem.querySelector('.accordion-content[data-submenu-index="' + index + '"]');
    const isOpen = accordionItem.classList.contains('open');
    
    // Handle mobile menu navigation logic
    if (isMobileItem) {
      const parentLink = header.querySelector('.mobile-menu-link');
      const isLink = parentLink && parentLink.tagName.toLowerCase() === 'a' && 
                    parentLink.getAttribute('href') && parentLink.getAttribute('href') !== '#';
      
      if (isOpen && parentLink && e.target === parentLink && isLink) {
        return; // Allow navigation
      }
      if (!isOpen && parentLink && e.target === parentLink && isLink) {
        e.preventDefault(); // Prevent navigation, open accordion first
      }
    }
  
    // === Updated contextSelector logic ===
    let contextSelector;
    if (isFooterItem) {
      contextSelector = '.footer-accordion-item';
    } else if (isMobileItem) {
      contextSelector = '.mobile-menu-item';
    } else {
      contextSelector = '.accordion-item';
    }
  
    // Close other open accordions in the same context
    document.querySelectorAll(contextSelector + '.open').forEach(function(openItem) {
      if (openItem !== accordionItem) {
        openItem.classList.remove('open');
        const openHeader = openItem.querySelector('.accordion-header');
        if (openHeader) openHeader.setAttribute('aria-expanded', 'false');
        const openContent = openItem.querySelector('.accordion-content');
        if (openContent) {
          openContent.style.maxHeight = '0';
        }
      }
    });
  
    // Toggle current accordion
    if (!isOpen) {
      accordionItem.classList.add('open');
      header.setAttribute('aria-expanded', 'true');
      content.style.maxHeight = content.scrollHeight + "px";
    } else {
      accordionItem.classList.remove('open');
      header.setAttribute('aria-expanded', 'false');
      content.style.maxHeight = '0';
    }
  });


    // Keyboard accessibility
    header.addEventListener('keydown', function(e) {
      const accordionItem = header.closest('.accordion-item');
      const isFooterItem = accordionItem.classList.contains('footer-accordion-item');
      
      if (isFooterItem && window.innerWidth > 768) return;
      
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        header.click();
      }
    });
  });

  // Reset footer accordion state on window resize
  window.addEventListener('resize', function() {
    if (window.innerWidth > 768) {
      document.querySelectorAll('.footer-accordion-item').forEach(function(item) {
        item.classList.remove('open');
        const header = item.querySelector('.accordion-header');
        if (header) header.setAttribute('aria-expanded', 'false');
        const content = item.querySelector('.accordion-content');
        if (content) {
          content.style.maxHeight = 'none';
        }
      });
    } else {
      // Reset to closed state on mobile
      document.querySelectorAll('.footer-accordion-item').forEach(function(item) {
        if (!item.classList.contains('open')) {
          const content = item.querySelector('.accordion-content');
          if (content) {
            content.style.maxHeight = '0';
          }
        }
      });
    }
  });
});